// Chakra imports
import { Flex, Text, CircularProgress } from "@chakra-ui/react";
import Card from "components/card/Card";
import TimelineRow from "components/dataDisplay/TimelineRow";
import {
  buscarItemPedidoPorIdCliente,
  buscarPedidosPorId,
  PesquisarItensPedidosPorId,
} from "config/apis/requests";
import { IsEmpty } from "config/functions";
import track from "assets/img/track.png";
import { isEmpty } from "@chakra-ui/utils";
import { useEffect, useState } from "react";

export default function Rastreio(props: {
  dataUser: any;
  midias: any;
  codigoProduto: any;
}) {
  const { dataUser, midias, codigoProduto } = props;

  // ⬇️ Agora é um estado reativo
  const [cartaoJae, setCartaoJae] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [nrRastreioItemPedido, setNrRastreioItemPedido] = useState("");

  useEffect(() => {
    if (!isEmpty(dataUser) && !isEmpty(midias)) {
      setLoading(true);
      PesquisarItensPedidosPorId(dataUser.codigo).then(function (result) {
        if (!IsEmpty(result)) {
          const pedidosPagosSemCancelamento = result?.filter(
            (pedido: any) =>
              pedido.statusPedido !== "CANCELADO" &&
              pedido.dataCancelamento === null
          );

          const itensPedidosFiltrados = pedidosPagosSemCancelamento.flatMap(
            (pedido: any) =>
              pedido.itensPedido
                .filter(
                  (item: any) =>
                    [3, 6, 5].includes(item.idTipoItemPedido) &&
                    item.nrRastreamento !== null &&
                    item.nrRastreamento !== undefined
                )
                .map((item: any) => ({
                  idCliente: item.idCliente,
                  idItemPedido: item.idItem,
                  idPedido: pedido.numero,
                  idProduto: item.idProduto,
                  nrRastreamento: item.nrRastreamento,
                }))
          );
          if (!IsEmpty(itensPedidosFiltrados)) {
            const cartoesJaeFiltrados = itensPedidosFiltrados.filter(
              (cartao: any) => cartao.idProduto === 1 || cartao.idProduto === 6
            );

            const cartaoJaeCard = cartoesJaeFiltrados.length
              ? [
                  cartoesJaeFiltrados.reduce((maior: any, atual: any) =>
                    atual.idItemPedido > maior.idItemPedido ? atual : maior
                  ),
                ]
              : [];

            const cartoesVTFiltrados = itensPedidosFiltrados.filter(
              (cartao: any) => cartao.idProduto === 2
            );

            const cartaoJaeVtCard = cartoesVTFiltrados.length
              ? [
                  cartoesVTFiltrados.reduce((maior: any, atual: any) =>
                    atual.idItemPedido > maior.idItemPedido ? atual : maior
                  ),
                ]
              : [];

            const cartaoJaeGratuidadeCardFilter = itensPedidosFiltrados.filter(
              (cartao: any) => cartao.idProduto === 3
            );

            const cartaoJaeGratuidadeCard = cartaoJaeGratuidadeCardFilter.length
              ? [
                  cartaoJaeGratuidadeCardFilter.reduce(
                    (maior: any, atual: any) =>
                      atual.idItemPedido > maior.idItemPedido ? atual : maior
                  ),
                ]
              : [];

            // ⬇️ Atualiza o estado com os valores válidos
            setCartaoJae(
              [
                cartaoJaeCard[0],
                cartaoJaeVtCard[0],
                cartaoJaeGratuidadeCard[0],
              ].filter(Boolean)
            );

            setLoading(false);
          }
        } else {
          setLoading(false);
          setCartaoJae([]);
        }
      });
      setLoading(false);
    }
  }, [dataUser, midias]);

  return (
    <>
      <Card mb={5} bgImage={track} bgBlendMode={"unset"}>
        <Flex direction="column">
          <Flex direction="column" mb="2%" w={"100%"}>
            <Text fontSize="xl" fontWeight="bold">
              Rastreio cartão
            </Text>
          </Flex>
          <Flex direction="column">
            <Flex w={"100%"} mt={"22px"} direction={"column"}>
              {cartaoJae.length === 0 && loading === true ? (
                <Flex
                  flexDirection="row"
                  justifyContent="center"
                  align="center"
                  width={"100%"}
                >
                  <CircularProgress
                    isIndeterminate
                    color="green.300"
                    size="45px"
                  />
                </Flex>
              ) : cartaoJae.length > 0 && loading === false ? (
                cartaoJae.map((item: any, index: number) => {
                  const {
                    idCliente,
                    idItemPedido,
                    idPedido,
                    idProduto,
                    nrRastreamento,
                  } = item;
                  return (
                    <TimelineRow
                      key={index}
                      nrRastreamento={nrRastreamento}
                      idCliente={idCliente}
                      idItemPedido={idItemPedido}
                      idPedido={idPedido}
                      idProduto={idProduto}
                      item={index}
                    />
                  );
                })
              ) : (
                cartaoJae.length == 0 &&
                !loading && (
                  <Text fontSize="sm" fontWeight="400" ms="2px">
                    <b>Sem dados de rastreio</b>
                  </Text>
                )
              )}
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </>
  );
}
